import { create } from 'zustand';

interface GuideState {
  isOpen: boolean;
  activeArticleId: string | null;
  searchQuery: string;
  openGuide: (articleId?: string) => void;
  closeGuide: () => void;
  toggleGuide: () => void;
  setActiveArticle: (id: string | null) => void;
  setSearchQuery: (q: string) => void;
}

export const useGuideStore = create<GuideState>((set) => ({
  isOpen: false,
  activeArticleId: null,
  searchQuery: '',
  openGuide: (articleId) =>
    set({ isOpen: true, activeArticleId: articleId ?? null, searchQuery: '' }),
  closeGuide: () =>
    set({ isOpen: false, activeArticleId: null, searchQuery: '' }),
  toggleGuide: () =>
    set((s) => ({
      isOpen: !s.isOpen,
      ...(!s.isOpen ? {} : { activeArticleId: null, searchQuery: '' }),
    })),
  setActiveArticle: (id) => set({ activeArticleId: id, searchQuery: '' }),
  setSearchQuery: (q) => set({ searchQuery: q, activeArticleId: null }),
}));
